<div mat-dialog-content>
  <p>{{'model.addlabel' | translate}}</p>
  <mat-form-field>
    <input matInput cdkFocusInitial [(ngModel)]="data">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data" (keyup.enter)="close($event)" cdkFocusInitial>{{'model.confirm.ok' | translate}}</button>
  <button mat-button (click)="onNoClick()">{{'model.confirm.cancel' | translate}}</button>
</div>